
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Das ist ein Mythos, der wissenschaftlich nie bestätigt werden konnte. `}<M mdxType="M">{`Ob wir vor oder nach Mitternacht schlafen, spielt keine Rolle.`}</M>{` Entscheidend sind viel eher die Tiefe, die Qualität und der Rhythmus des Schlafens. Besonders wertvoll ist der Tiefschlaf, weil sich hier der Körper am besten erholt, und unser Immunsystem gestärkt wird. In den Phasen des Tiefschlafs ist der Körper regungslos, die Muskeln sind entspannt und die Augen ruhig. In den ersten zwei bis vier Stunden nach dem Einschlafen schläft man besonders tief. Wer entsprechend früh ins Bett geht, erlebt diese Phase also noch vor Mitternacht. In der zweiten Schlafhälfte ist der Körper dagegen häufiger in einem Zustand, der dem Wachsein ähnelt. Das Gehirn ist aktiv, Herzfrequenz und Atmung nehmen zu, der Blutdruck steigt, die Augenlider flackern. An Träume aus dieser Schlafphase können wir uns besonders häufig erinnern.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;